import store from './store'
import { Message } from 'element-ui'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
import { getToken, setToken } from '@/utils/auth'
import { isPathMatch } from '@/utils/validate'
import { isRelogin } from '@/utils/request'
import router, { constantRoutes, dynamicRoutes } from './router'

NProgress.configure({ showSpinner: false })

const whiteList = ['/login', '/']

const isWhiteList = (path) => {
  return whiteList.some(pattern => isPathMatch(pattern, path))
}

const searchParams = function (url, key) {
  const params = {}
  // Extract query parameters from hash or search
  const queryString = url.includes('?') ? url.split('?')[1] : (url.includes('#') ? url.split('#')[1] : '')

  if (queryString) {
    // Remove any path after the query parameters
    const cleanQuery = queryString.split('#')[0]

    cleanQuery.split('&').forEach(param => {
      const [paramKey, paramValue] = param.split('=')
      if (paramKey) {
        params[decodeURIComponent(paramKey)] = decodeURIComponent(paramValue || '')
      }
    })
  }

  return params
}
router.beforeEach((to, from, next) => {
  // next()
  // return
  if (getToken()) {
    // 动态设置页面标题
    // to.meta.title && store.dispatch('settings/setTitle', to.meta.title)
    /* has token */
    if (to.path === '/login') {
      next({ path: '/' })
      NProgress.done()
    } else if (isWhiteList(to.path) && to.path !== '/') {
      next()
    } else {
      console.log('==========1', store.state.isBalance)
      if (store.state.user && Object.keys(store.state.user).length > 0 && store.state.isBalance) {
        next()
      } else {
        if (!store.state.isBalance && to.path == '/NewOrder' && process.env.VUE_APP_MODE == 'production') {
          next({ path: '/' })
          return
        }
        isRelogin.show = true
        // 判断当前用户是否已拉取完user_info信息
        store.dispatch('GetInfo').then((res) => {
          isRelogin.show = false
          store.commit('SET_USERINFO', res.user)
          // 登录后调用配置
          store.dispatch('initBusinessSetting')
          next()
        }).catch(err => {
          store.dispatch('LogOut').then(() => {
            Message.error(err)
            next({ path: '/' })
          })
        })
      }
    }
  } else {
    // 没有token
    if (isWhiteList(to.path)) {
      // 检查URL中是否包含token参数（用于第三方登录如Google）
      const currentUrl = window.location.href
      const params = searchParams(currentUrl)
      const googleToken = params.token || params.access_token
      if (googleToken) {
        setToken(googleToken)
        store.dispatch('LoginEmail', { token: googleToken }).then((res) => {
          // 登录成功后跳转到首页
          console.log('登录成功234:', res)
          localStorage.setItem('user', JSON.stringify(res.data.user))
          store.dispatch('GetInfo')
          // store.dispatch('initBusinessSetting')
          next({ path: '/' })
        }).catch((err) => {
          console.log('登录成功56:', err)
          // 登录失败后跳转到登录页
          // next({ path: '/login' });
        })
      } else {
        // 没有token且不在白名单，重定向到登录页
        // next({ path: '/' });
        next()
      }
      // 在免登录白名单，直接进入
    } else {
      // 检查URL中是否包含token参数（用于第三方登录如Google）
      const currentUrl = window.location.href
      const params = searchParams(currentUrl)
      const googleToken = params.token || params.access_token
      if (googleToken) {
        setToken(googleToken)
        store.dispatch('LoginEmail', { token: googleToken }).then((res) => {
          // 登录成功后跳转到首页
          console.log('登录成功234:', res)
          localStorage.setItem('user', JSON.stringify(res.data.user))
          store.dispatch('GetInfo')
          // store.dispatch('initBusinessSetting')
          next({ path: '/' })
        }).catch((err) => {
          console.log('登录成功56:', err)
          // 登录失败后跳转到登录页
          // next({ path: '/login' });
        })
      } else {
        // 没有token且不在白名单，重定向到登录页
        next({ path: '/' })
      }
    }
  }
})
router.afterEach(() => {
  NProgress.done()
})
